import {
    types,
} from 'mobx-state-tree';

export const OTP = types
    .model({
        loading: types.optional(types.boolean, false),
        isDisableResendOTP: types.optional(types.boolean, false),
        isOpenDialog: types.optional(types.boolean, false),
        state: types.optional(types.enumeration(['pending', 'success']), 'pending'),
        loadingState: types.optional(types.enumeration(['pending', 'success']), 'pending')
    })
    .actions(self => ({
        setLoading(loading) {
            self.loading = loading;
        },
        changeDisableResendOTP(isDisable) {
            self.isDisableResendOTP = isDisable
        },
        setOpenDialog() {
            self.isOpenDialog = true
        },
        setState(state = 'pending') {
            self.state = state
        },
        setLoadingState(state = 'pending') {
            self.loadingState = state
        }
    }))
